import React, { useEffect } from 'react';
import { updateSocialMeta } from '../utils/seo';
import { Trophy } from 'lucide-react';

const Contest = () => {
  useEffect(() => {
    document.title = 'Contest - Pin High Golf & Lounge';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Pin High Golf & Lounge contest. Scan the QR code to play.'
      );
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://pinhighbay.com/contest');
    updateSocialMeta({
      title: 'Contest - Pin High Golf & Lounge',
      description: 'Pin High Golf & Lounge contest. Scan the QR code to play.',
      path: '/contest',
    });
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <section className="relative py-24 bg-gradient-to-br from-green-600 to-green-800 text-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Trophy className="w-16 h-16 mx-auto mb-6 text-green-300" />
          <h1 className="text-5xl md:text-6xl font-bold mb-4 tracking-tight">
            Contest
          </h1>
          <p className="text-xl md:text-2xl text-green-50">
            Bring the ball into Pin High to collect your prize.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Contest;
